module.exports = __webpack_public_path__ + "static/media/softwareWest.29d1d161.png";